<template>
  <div class="show-profile" v-if="seen">
    <div class="content" :class="{ 'content-archived': !user.data.isActive && user.data.access_status == 'ARCHIVED' }">
      <div class="row mb-3">
        <div class="col-3">
          <div class="photo">
            <template v-if="user.data.photo">
              <span class="default-pic">
                <img :src=getPhoto(user.data.photo) class="img-fluid" />
              </span>
            </template>
            <template v-if="!user.data.photo">
              <span class="profile-pic">
                <span class="default-pic">{{ getName(user.names) }}</span>
              </span>
            </template>
          </div>
        </div>
        <div class="col-7">
          <p>
            <span class="user-badge" v-if="!user.data.isActive && user.data.access_status == 'BLOCKED'"
              :class="{ 'blocked': !user.data.isActive && user.data.access_status == 'BLOCKED' }">Blocked</span>
            <span class="user-badge" v-if="!user.data.isActive && user.data.access_status == 'ARCHIVED'"
              :class="{ 'archived': !user.data.isActive && user.data.access_status == 'ARCHIVED' }">Archived</span>
            <span class="user-badge" v-if="user.data.isActive" :class="{ 'active': user.data.isActive }">Active</span>
          </p>
          <h4 class="mb-1 text-black">{{ user.names }}</h4>
          <p class="mb-1 d-flex align-items-center flex-row">
            <img src="@/assets/User-Icon.svg" />&nbsp;&nbsp;
            <span>{{ user.department }}</span>
          </p>
          <p class="mb-1 d-flex align-items-center flex-row">
            <img src="@/assets/Email-Icon.svg" />&nbsp;&nbsp;
            <span>{{ user.data.email }}</span>
          </p>
          <div class="users-btn mt-3"
            v-if="!user.data.isActive && user.data.access_status == 'BLOCKED' || user.data.isActive">
            <span class="atn-btn mr-2 edit" @click="edit()">
              <img src="@/assets/Edit-Pen.svg" width="15px" height="13" />&nbsp;
              <span>Edit</span>
            </span>
            <span class="atn-btn mr-2" @click="unblock(user.data._id, user.names)" v-if="!user.data.isActive">
              <img src="@/assets/Unblock-User.svg" width="18px" height="16px" />
            </span>
            <span class="atn-btn mr-2" @click="block(user.data._id, user.names)" v-if="user.data.isActive">
              <img src="@/assets/Delete-User.svg" width="18px" height="16px" />
            </span>
            <span class="atn-btn" @click="delete_user(user.data._id, user.names)">
              <img src="@/assets/Delete-Btn.svg" width="16px" height="16px" />
            </span>
          </div>
        </div>
        <div class="col-2">
          <span class="close" @click="close">
            <img src="@/assets/Close.svg" width="12px" height="12px" />
          </span>
        </div>
      </div>
      <div class="container my-4">
        <div class="row user-file-stats">
          <div class="col d-flex justify-content-center align-items-center flex-column">
            <h5>{{ user.sharedfiles }}</h5>
            <p>Shared Files</p>
          </div>
          <div class="col d-flex justify-content-center align-items-center flex-column">
            <h5>{{ user.sharedwith }}</h5>
            <p>Shared With Me</p>
          </div>
          <div class="col d-flex justify-content-center align-items-center flex-column">
            <h5>{{ user.totalfolders }}</h5>
            <p>Folders</p>
          </div>
          <div class="col d-flex justify-content-center align-items-center flex-column">
            <h5>{{ user.totalfiles }}</h5>
            <p>Files</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center mt-3">
          <router-link :to=url class="view-user-files">View Files</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.text-black {
  color: #111;
  font-weight: bold;
}

.user-badge {
  padding: 6px 10px;
  font-size: 13px;
  border-radius: 4px;
}

.user-badge.active {
  background-color: #E2F8EC;
  color: #40D886;
}

.user-badge.archived {
  background-color: #E8F0F6;
  color: #677888;
}

.user-badge.blocked {
  background-color: #FFEBEB;
  color: #FC6D6C;
}

.default-pic {
  background: #e2e8f0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #71809a;
  width: 120px;
  height: 120px;
  font-size: 3rem;
  font-weight: bold;
  box-shadow: 0px 0px 10px 0px rgba(97, 96, 96, 0.24);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(97, 96, 96, 0.24);
  -moz-box-shadow: 0px 0px 10px 0px rgba(97, 96, 96, 0.24);
  border: 3px solid #FFFFFF;
}

.default-pic img {
  border-radius: 50%;
}

.profile-pic {
  display: inline-block;
  height: 120px;
  width: 120px;
}

.profile-pic {
  cursor: pointer;
}

.content {
  position: relative;
}

.close {
  background-color: #F2F7FC;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 32px;
  height: 32px;
}

.close-btn2 {
  cursor: pointer;
}
</style>
<script>
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      seen: false,
      file_id: '',
      url: '',
      user: {},
      index: null,
      backendUrl: this.$store.getters.BACKENDURL
    }
  },
  methods: {
    getPhoto(url) {
      return `${this.backendUrl}/static-photos/${url}`
    },
    delete_user(id, name) {
      this.seen = false
      this.$parent.delete_user(id, name, this.index)
    },
    unblock(id, names) {
      this.seen = false
      this.$parent.unblockuser(this.index, id, names)
    },
    block(id, names) {
      this.seen = false
      this.$parent.blockuser(this.index, id, names)
    },
    edit() {
      console.log('po')
      this.seen = false
      this.$parent.edit_user(this.index)
    },
    load(user, index) {
      this.index = index
      this.file_id = user._id
      this.url = '/user/files/' + this.file_id
      this.seen = true
      this.user = user
    },
    getName(name) {
      return name[0]
    },
    close(evt) {
      if (evt.target.className == 'show-profile') {
        this.seen = false
        return
      }

      this.seen = false
    }
  }
}
</script>
